import {
  DocumentType,
  isValidCIF,
  isValidDNI,
  isValidNIE,
  isValidPassportNumber,
  NationalIdType,
} from '@nemuru-eng/js-api-client';

export const validateDocumentNumber = (
  documentNumber: string | null | undefined,
  documentType: DocumentType | NationalIdType | null,
) => {
  if (!documentType || !documentNumber) return false;
  switch (documentType) {
    case DocumentType.NIF:
      return isValidDNI(documentNumber);
    case DocumentType.NIE_EU:
    case DocumentType.NIE_NON_EU:
    case NationalIdType.NIE:
      return isValidNIE(documentNumber);
    case DocumentType.PASSPORT:
      return isValidPassportNumber(documentNumber);
    case NationalIdType.CIF:
      return isValidCIF(documentNumber);
    default:
      return false;
  }
};
